(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bn-fall-countdown"] && !Shopify.designMode) return;
  try {
    
function initBnCountdown(){document.querySelectorAll('[data-bn-countdown]').forEach(function(banner){if(banner.dataset.ready)return;banner.dataset.ready='true';const end=Date.parse(banner.dataset.end);const clock=banner.querySelector('[data-clock]');function tick(){const remaining=end-Date.now();if(remaining<=0){banner.hidden=true;return false;}const seconds=Math.floor(remaining/1000);clock.textContent=Math.floor(seconds/86400)+'d '+String(Math.floor(seconds%86400/3600)).padStart(2,'0')+'h '+String(Math.floor(seconds%3600/60)).padStart(2,'0')+'m '+String(seconds%60).padStart(2,'0')+'s';return true;}if(tick()){const timer=setInterval(function(){if(!banner.isConnected||!tick())clearInterval(timer);},1000);}});}
initBnCountdown();document.addEventListener('shopify:section:load',initBnCountdown);document.addEventListener('click',function(event){const link=event.target.closest('[data-bn-referral-launch]');if(!link)return;const launcher=document.getElementById('appstle-loyalty-button');if(launcher){event.preventDefault();launcher.click();}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bn-fall-event"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const link = event.target.closest('[data-bn-rewards]');
  if (!link) return;
  const launcher = document.getElementById('appstle-loyalty-button');
  if (launcher) { event.preventDefault(); launcher.click(); }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["daily-repair-calm-landing"] && !Shopify.designMode) return;
  try {
    
class DailyRepairCalmGalleryCounter {
  constructor() {
    this.gallery = document.querySelector('.product__media-list.slider--mobile');
    this.counter = document.querySelector('.product__media-list.slider--mobile')?.closest('slider-component')?.querySelector('.slider-counter');
    this.mediaQuery = window.matchMedia('(max-width: 749px)');
    this.sync = this.sync.bind(this);
    if (!this.gallery || !this.counter) return;
    this.gallery.addEventListener('scroll', this.sync, { passive: true });
    this.mediaQuery.addEventListener('change', this.sync);
    window.addEventListener('resize', this.sync);
    this.sync();
  }

  sync() {
    const slides = Array.from(this.gallery.querySelectorAll('.slider__slide'));
    const current = this.counter.querySelector('.slider-counter--current');
    const total = this.counter.querySelector('.slider-counter--total');
    if (!slides.length || !current || !total) return;
    const closestSlide = slides.reduce((closest, slide) => {
      return Math.abs(slide.offsetLeft - this.gallery.scrollLeft) < Math.abs(closest.offsetLeft - this.gallery.scrollLeft) ? slide : closest;
    });
    current.textContent = String(slides.indexOf(closestSlide) + 1);
    total.textContent = String(slides.length);
  }
}

new DailyRepairCalmGalleryCounter();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
